import { render, staticRenderFns } from "./InstantPayoutModal.vue?vue&type=template&id=e6e40e6e"
import script from "./InstantPayoutModal.vue?vue&type=script&lang=js"
export * from "./InstantPayoutModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports